export default {
  label: "Anlagenübersicht",
  allAssets: "Alle Anlagen",
  assetHistory: {
    button: "Anlagenhistorie",
    close: "Historie schließen",
    preview: "UI-Vorschau",
    mockNotice:
      "Nur Beispieldaten. Diese Ereignisse sind nicht die Historie dieser Anlage. Es ist kein Historien-Backend angebunden.",
    changeLog: "Änderungsverlauf",
    newestFirst: "Neueste zuerst",
    edit: "Anlage bearbeitet",
    fieldsChanged: "Felder geändert",
    expandChanges: "Feldänderungen anzeigen",
    collapseChanges: "Feldänderungen ausblenden",
    initialUpload: "Erster Upload",
    locationValuesHidden: "Standortwerte werden nicht angezeigt.",
    hiddenUser: "Nicht angezeigt",
    privacyNotice:
      "Hochladende Benutzer sind nur für Plattformbetreiber sichtbar. Bei späteren Änderungen sehen Anlagenbetreiber nur Benutzer der eigenen Organisation.",
    empty: "Keine Historieneinträge vorhanden.",
    loading: "Historie wird geladen",
    loadError: "Die Historie konnte nicht geladen werden. Bitte erneut versuchen oder die Zugriffsrechte prüfen.",
    retry: "Erneut versuchen",
    changedOnly: "Geändert; Werte werden nicht protokolliert.",
    labelsUnavailable: "Einige Namen konnten nicht geladen werden. Stattdessen werden verfügbare IDs angezeigt.",
    columns: {
      timestamp: "Datum & Uhrzeit",
      field: "Feld / Ereignis",
      before: "Alter Wert",
      after: "Neuer Wert",
      user: "Benutzer",
      tenant: "Organisation",
    },
    fields: {
      creation: "Anlage hochgeladen",
      organisation: "Organisation",
      approval: "Freigabestatus",
      project: "Projekt",
      location: "Anlagenposition",
      contact: "Kontakte",
      directory: "Kontakt",
      note: "Bemerkung",
      serialNo: "Anlagenkennung",
      comment: "Kommentar",
      commissioningDate: "Inbetriebnahme",
      constructionDate: "Errichtung",
      assetModel: "Anlagenmodell",
      parentAsset: "Übergeordnete Anlage",
      billingAddress: "Rechnungsadresse",
      streetAccessPoint: "Zuwegungspunkt",
      accessRoutes: "Zuwegung",
      locationOther: "Standort",
      attribute: "Anlagenattribut",
      media: "Medien und Dateien",
      safetyNotes: "Produktsicherheitsinformationen",
      other: "Feldänderung",
    },
    directoryFields: {
      Name: "Name",
      FirstName: "Vorname",
      LastName: "Nachname",
      Email: "E-Mail",
      Phone: "Telefon",
      Note: "Bemerkung",
    },
    billingAddressFields: {
      Name: "Name",
      Email: "E-Mail",
      StreetAndNumber: "Straße und Hausnummer",
      Zipcode: "PLZ",
      City: "Ort",
      Country: "Land",
      Note: "Bemerkung",
      PurchaseOrderNumber: "PO Nummer",
    },
    organisations: {
      current: "Demo-Organisation",
      previous: "Vorherige Demo-Organisation",
      platform: "Demo-Plattform",
    },
    actors: {
      current: "Demo-Anlagenbetreiber",
      previous: "Vorheriger Demo-Anlagenbetreiber",
      platform: "Demo-Plattformbetreiber",
    },
    values: {
      previousOrganisation: "Vorherige Demo-Organisation",
      currentOrganisation: "Demo-Organisation",
      pending: "Ausstehend",
      approved: "Freigegeben",
      projectBefore: "Demo-Windpark Nord",
      projectAfter: "Demo-Windpark Süd",
      contactBefore: "Demo-Kontakt A",
      contactAfter: "Demo-Kontakt B",
      noteAfter: "Beispielhinweis zur Wartung",
    },
  },
  userAccessReport: {
    button: "Benutzerzugriffsbericht herunterladen",
    title: "Benutzerzugriffsbericht herunterladen",
    description:
      "Wählen Sie optional einen Datumsbereich. Bleiben beide Felder leer, wird das aktuelle Quartal verwendet.",
    startDate: "Startdatum",
    endDate: "Enddatum",
    submit: "Herunterladen",
    downloading: "Wird heruntergeladen...",
    cancel: "Abbrechen",
    invalidRangeError: "Das Startdatum muss vor dem Enddatum liegen.",
    notAuthorizedError: "Sie sind nicht berechtigt, diesen Bericht herunterzuladen.",
    genericError: "Der Bericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
  },
  batchEdit: {
    button: "Batch Bearbeitung",
    title: "Batch Bearbeitung",
    selectedAssets: "Ausgewählte Anlagen",
    emptyFieldsHint: "Leer gelassene Felder werden nicht überschrieben.",
    organisation: "Organisation",
    organisationDisabledHint: "Nur Plattformbetreiber können die Organisation ändern.",
    billingAddress: "Rechnungsadresse",
    contacts: "Notfallkontakte",
    contactsReplaceHint: "Die ausgewählten Kontakte ersetzen die bestehenden Kontakte der Anlagen.",
    attachment: "PDF-Anhang",
    attachmentColumn: "PDF",
    attachmentAddHint: "Das PDF wird zu den bestehenden Dateien der Anlagen hinzugefügt.",
    attachmentFileNameRequired: "Bitte einen Dateinamen eingeben.",
    save: "Bearbeitung speichern",
    resultTitle: "Ergebnis der Batch Bearbeitung",
    resultSummary: "{success} von {total} Anlagen erfolgreich aktualisiert.",
    statusSuccess: "Erfolgreich",
    statusFailed: "Fehlgeschlagen",
    statusSkipped: "Übersprungen",
    statusUnchanged: "Nicht geändert",
    skippedHint: "Nicht ausgeführt, da ein vorheriger Schritt für diese Anlage fehlgeschlagen ist.",
    failedHint: "Die Änderung konnte nicht gespeichert werden.",
    contactsNotRemovedHint:
      "Die neuen Kontakte wurden hinzugefügt, die alten Kontakte konnten aber nicht entfernt werden.",
    retryFailed: "Fehlgeschlagene erneut versuchen",
  },
  tabs: {
    assets: {
      deleteAsset: "Anlage löschen",
      pendingAssets: "Ausstehende Anlagen",
      deleteAssetMessagePart1: "Sie löschen die Anlage",
      deleteAssetMessagePart2: "aus der Datenbank. Sind Sie sicher, dass Sie fortfahren möchten?",
      deleteAssetMessagePluralPart1: "Sie löschen die Anlagen",
      allAssetView: "Ansicht aller Anlagen",
      projectView: "Projektansicht",
      label: "Anlagen",
      labelForProjectAndAssetView: "Anlagen & Projekte",
      asset: "Anlage",
      generalInfos: "Allgemeine Informationen",
      note: "Bemerkung",
    },
    importAssets: {
      importSuccessTitle: "Anlagen erfolgreich importiert",
      importSuccessMessage:
        "Alle Anlagen wurden erfolgreich hochgeladen. Um den Import abzuschließen,wechseln Sie bitte in den Reiter „Ausstehende Anlagen“ und vervollständigen Sie die Dateneingabe.",
      importNotPossibleTitle: "Anlagen konnten nicht importiert werden",
      importNotPossibleMessagePart1:
        "Der Import von Anlagen ist fehlgeschlagen. Es wurden Fehler in mindestens einer Anlage festgestellt: ",
      importNotPossibleMessagePart2:
        "Bitte überprüfen Sie die hochgeladene Datei noch einmal und versuchen Sie es erneut. Häufige Probleme sind:",
      importNotPossibleMessagePart3: "Doppelte Anlagen (zwei oder mehr Anlagen mit der gleichen Seriennummer)",
      importNotPossibleMessagePart4: "Anlage existiert bereits",
      importNotPossibleMessagePart5: "Falsches Format der erforderlichen Daten",
      importNotPossibleMessagePart6: "Fehlende erforderliche Daten",
    },
    assetGroups: {
      label: "Anlagegruppen",
      list: "Anlagenliste",
      activities: "Aktivitäten",
      newAssetGroup: "Neue Anlagegruppe",
      sort: {
        labelAsc: "ASC",
        labelDesc: "DESC",
      },
    },
    assetTags: {
      updateTags: "Tags aktualisieren",
    },
    assetTypes: {
      deleteAssetType: "Anlagentypen löschen",
      label: "Anlagentypen",
      newAssetType: "Neuer Anlagentyp",

      deleteAssetTypeMessagePart1: "Dieser AnlagenTyp kann nicht gelöscht werden, da er mit ",
      deleteAssetTypeMessagePart2:
        "Modell(e) Instanzen. Damit ein AnlagenTyp gelöscht werden kann, da er mit Modellen verknüpft ist",
      deleteAssetTypeMessage: "Sind Sie sicher, dass Sie diesen Anlagentyp löschen möchten?",
      resetToDefaultValue: "Zurücksetzen auf Standardwert",
      deleteAssetModelErrorMessage:
        "Bitte achten Sie darauf, nur Anlagenmodell zu löschen, denen keine Anlagen zugewiesen sind!",
      deleteAssetModelSuccessMessage: "Sie haben diese Anlagenmodelle erfolgreich gelöscht!",
      deleteAssetModelWarningMessage:
        "Bitte achten Sie darauf, nur Anlagenmodell zu löschen, denen keine Anlagen zugewiesen sind! Folgende Anlagen sind diesem Anlagemnodell zugewiesen.",
      deleteImage: {
        modalTitle: "Bild löschen",
        modalMessage: "Möchten Sie dieses Bild wirklich löschen?",
      },
    },
    assetModels: {
      deleteAssetModel: "Anlagenmodell löschen",
      deleteAssetModelMessage: "Sind Sie sicher, dass Sie dieses Anlagenmodell löschen möchten?",
      deleteAssetModelTitle: "Anlagenmodell löschen",

      deleteNotPossibleMessagePart1: "Dieses Anlagenmodell kann nicht gelöscht werden, da ihm ",
      deleteNotPossibleMessagePart2:
        "Anlage(n) zugeordnet sind. Damit ein Anlagenmodell gelöscht werden kann, dürfen keine Anlagen existieren.",
      deleteNotPossibleBecauseTheseModelsHaveAssets1:
        "Die ausgewählten Anlagenmodelle können nicht gelöscht werden, da nachfolgenden Modellen Anlagen zugewiesen sind:",
      deleteNotPossibleBecauseTheseModelsHaveAssets2:
        "Damit Anlagenmodelle gelöscht werden können, dürfen keine Anlagen zugeordnet sein.",
    },
    assetDetails: {
      label: "Anlagendetails",
      assetDetailsPageTabs: {
        position: "Position",
        addAnotherModel: "Ein weiteres Modell hinzufügen",
        attributes: "Attribute",
        photos: "Fotos",
        otherDocuments: "Andere Dokumente",
        assetPictures: "Anlagenbilder",
        mediaAndFiles: "Medien und Dateien",
        fileName: "Dateiname",
        fileSize: "Dateigröße [MB]",
        selectFile: "Datei auswählen",
        uploadedOn: "Hochgeladen am",
        comments: "Kommentare",
        changes: "Änderungen",
        deleteFilesMessage: "Möchten Sie die ausgewählten Dateien wirklich löschen?",
        deleteFileMessage: "Möchten Sie die ausgewählte Datei wirklich löschen?",
      },
    },
    assetAttributeFieldsAndSets: {
      label: "Attributfelder und -Sätze",
      deleteMessage:
        "Das Löschen dieses Satzes wirkt sich auf alle Anlagentypen aus, die ihn zur Anzeige der Attributwerte ihrer Instanzen ausgewählt haben. Sind Sie sicher, dass Sie es löschen wollen?",
      deleteAssetAttributeSets: "Attributsatz löschen",
      attributes: "Attribute",
      attribute: "Attribut",
      noAttributes: "Keine Attribute",
    },
    AssetAttributeSets: {
      label: "Attributsätze",
    },
    AssetAttributes: {
      createAssetAttribute: {
        successMessage: "Asset Attribut erfolgreich erstellt",
        errorMessage: "Fehler beim Erstellen des Asset Attributs",
      },
      editAssetAttribute: {
        successMessage: "Asset Attribut erfolgreich bearbeitet",
        errorMessage: "Fehler beim Bearbeiten des Asset Attributs",
      },
    },
    assetNewEntry: {
      label: "neue Einträge",
      newAssets: "Neue Anlagen",
      dateTime: "Datum & Uhrzeit",
    },
    projects: {
      label: "Projekte",
    },
    errorCodes: {
      noError: "Kein Fehler",
      fieldValidationError:
        "Einige Felder enthalten ungültige Daten. Bitte überprüfen Sie die nachfolgenden Felder und versuchen Sie es erneut.",
      csvParsingError:
        "Die Datei konnte nicht korrekt gelesen werden. Stellen Sie sicher, dass die Datei im richtigen Format vorliegt und keine beschädigten Daten enthält.",
      assetAlreadyExistsError:
        "Ein Eintrag mit derselben Anlage existiert bereits. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.",
      manufacturerMissing:
        "Herstellerangaben fehlen. Bitte füllen Sie alle erforderlichen Felder aus und versuchen Sie es erneut.",
      modelMissing:
        "Modellangaben fehlen. Bitte füllen Sie alle erforderlichen Felder aus und versuchen Sie es erneut.",
      unknownError:
        "Ein unbekannter Fehler ist aufgetreten. Bitte prüfen Sie ihre Eingaben oder wenden Sie sich an den Support.",
    },
    safetyNotes: {
      label: "Produktsicherheitsmitteilungen",
      newSafetyNote: "Neuer Produktsicherheitsmitteilung",
      updateSafetyNote: "Produktsicherheitsmitteilung bearbeiten",
      safetyNoteDetails: "Produktsicherheitsmitteilungsdetails",
      deleteSafetyNoteMessage: "Sind Sie sicher, dass Sie diesen Produktsicherheitsmitteilung löschen wollen?",
      deleteSafetyNote: "Produktsicherheitsmitteilung löschen",
    },
  },
};
